import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import UserOrderProductTable from './components/UserOrderProductTable';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    BottomNavigation,
    BottomNavigationAction,
    Dialog,
    DialogContent,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UserOrderAccordionHeader from './components/UserOrderAccordionHeader';
import '../../OrderDetail.scss';
import RestoreIcon from '@mui/icons-material/Restore';
import DeliveryCart from '../../../../assets/icons/svg/icons/delivery-cart.svg';
import UserCargoPackageDetails from './components/UserCargoPackageDetails/UserCargoPackageDetails';
import UserCargoStatusHistory from './components/UserCargoStatusHistory';
import UserShowProductOnFraudControl from './components/UserShowProductOnFraudControl';
import { useTranslation } from 'react-i18next';
import UserOutOfStockTable from './components/UserOutOfStockTable';
import './UserOrderProductDetail.scss';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import UserOrderPaymentInfos from './components/UserOrderPaymentInfos';
import PaymentIcon from '@mui/icons-material/Payment';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import UserCrossShipmentList from './components/UserCrossShipmentList';
import UserBillingInformation from './components/UserBillingInformation';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ListIcon from '@mui/icons-material/List';
import UserOrderShipmentStatusUpdate from './components/UserOrderShipmentStatusUpdate/UserOrderShipmentStatusUpdate';
import { OrderQuery } from '../../../../services/query';
import { UOPD_DETAIL } from './userOrderProductDetails.classes';

const selectedTabStyles = {
    fontWeight: 'bold',
    borderBottom: '3px solid #DEDEDE',
    paddingBottom: '5px',
};

function UserOrderProductDetail({ datas, orderInformation }: any) {
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const [tabsState, setTabsState] = useState<any>({});
    const { t } = useTranslation();
    const [summaryClicked, setSummaryClicked] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedShipmentForStatusUpdate, setSelectedShipmentForStatusUpdate] = useState(false);
    const [highlightedShipment, setHighlightedShipment] = useState<string | null>(null);
    const [reshippingActionButtonAllowed, setReshippingActionButtonAllowed] = useState(false);
    const location = useLocation();

    const GetReshippingActionButtonRule = () => {
        OrderQuery.GetReshippingActionButtonRule()
            .then((res: any) => {
                if (res) {
                    setReshippingActionButtonAllowed(res);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    useEffect(() => {
        GetReshippingActionButtonRule();
    }, []);

    const handleOpenModal = (e: any, shippingListId: any) => {
        e.stopPropagation();
        setSelectedShipmentForStatusUpdate(shippingListId);
        setOpenModal(true);
    };
    const handleCloseModal = (e: any) => {
        e.stopPropagation();
        setOpenModal(false);
    };
    const handleStatusModalClose = () => {
        setOpenModal(false);
    };
    useEffect(() => {
        const initialTabsState: any = {};
        datas.shippingListForBackofficeModels.forEach((shipment: any) => {
            initialTabsState[shipment.shippingListId] = 0;
        });
        setTabsState(initialTabsState);
    }, [datas.shippingListForBackofficeModels]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const shippingListNo = searchParams.get('shippingListNo');

        if (shippingListNo) {
            const shipmentIndex = datas.shippingListForBackofficeModels.findIndex(
                (shipment: any) => shipment.shippingListNo === shippingListNo
            );

            if (shipmentIndex !== -1) {
                setExpanded('panel' + shipmentIndex);
                setHighlightedShipment(shippingListNo);
                setTimeout(() => {
                    scrollToShipment(datas.shippingListForBackofficeModels[shipmentIndex].shippingListId);
                }, 100);

                setTimeout(() => {
                    setHighlightedShipment(null);
                }, 3000);
            }
        }
    }, [location.search, datas.shippingListForBackofficeModels]);

    const handleChange = (panel: any) => (_: any, isExpanded: any) => {
        if (summaryClicked) {
            setExpanded(isExpanded ? panel : false);
            setSummaryClicked(false);
        }
    };
    const handleTabChangeForShipment = (shipmentId: any, newValue: any) => {
        setTabsState((prevState: any) => ({
            ...prevState,
            [shipmentId]: newValue,
        }));
    };

    const OutOfStock = ({ outofstock }: any) =>
        outofstock.outofStockItems &&
        outofstock.outofStockItems.length > 0 && (
            <UserOutOfStockTable
                outOfStockItems={outofstock.outofStockItems}
                saleCh={datas.saleOrderPlatform}
                expanded={expanded}
            />
        );

    function scrollToShipment(shippingListId: any) {
        const element = document.getElementById('shipment-' + shippingListId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            const highlighted = document.querySelector('.highlighted');
            if (highlighted) {
                highlighted.classList.remove('highlighted');
            }
            element.classList.add('highlighted');
            setTimeout(() => {
                element.classList.remove('highlighted');
            }, 2000);
        }
    }

    const handleSummaryClick = () => {
        setSummaryClicked(true);
    };

    return (
        <>
            <div className={UOPD_DETAIL.root}>
                <Dialog
                    className={UOPD_DETAIL.statusDialog}
                    open={openModal}
                    onClose={(e: any) => handleCloseModal(e)}
                    slotProps={{
                        paper: {
                            className: UOPD_DETAIL.statusDialogPaper,
                            sx: {
                                minWidth: '400px',
                                maxWidth: '80%',
                                height: 'auto',
                            },
                        },
                    }}
                >
                    <DialogContent className={UOPD_DETAIL.statusDialogContent}>
                        <UserOrderShipmentStatusUpdate
                            shippingListId={selectedShipmentForStatusUpdate}
                            shipment={datas?.shippingListForBackofficeModels?.find(
                                (item: any) => item.shippingListId == selectedShipmentForStatusUpdate
                            )}
                            handleCloseModal={handleStatusModalClose}
                        />
                    </DialogContent>
                </Dialog>
                {datas.shippingListForBackofficeModels.map((shipment: any, index: number) => (
                    <>
                        <Accordion
                            id={'shipment-' + shipment.shippingListId}
                            expanded={expanded === 'panel' + index}
                            onChange={handleChange('panel' + index)}
                            key={index}
                            style={{
                                marginTop: '2rem',
                                height: 'auto',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                marginBottom: '4rem',
                            }}
                            className={`${index == 0 ? 'shipmentInfos' : ''} ${UOPD_DETAIL.shipmentAccordion} shippingListNo-${
                                shipment.shippingListNo
                            } ${highlightedShipment === shipment.shippingListNo ? 'highlighted-shipment' : ''}`}
                        >
                        <AccordionSummary
                            className={UOPD_DETAIL.shipmentSummary}
                                onClick={handleSummaryClick}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={'panel' + index + 'bh-content'}
                                id={'panel' + index + 'bh-header'}
                                sx={{
                                    '& .MuiAccordionSummary-expandIconWrapper': {
                                        position: 'absolute',
                                        right: '16px',
                                        top: '16px',
                                    },
                                    minHeight: '48px',
                                    padding: '8px 16px',
                                }}
                            >
                                <UserOrderAccordionHeader
                                    openModal={openModal}
                                    handleCloseModal={handleCloseModal}
                                    handleOpenModal={handleOpenModal}
                                    shipment={shipment}
                                    orderId={datas.orderId}
                                    customerId={datas.customerId}
                                    isExpanded={expanded === 'panel' + index}
                                    reshippingActionButtonAllowed={reshippingActionButtonAllowed}
                                />
                            </AccordionSummary>
                            <BottomNavigation
                                className={UOPD_DETAIL.bottomNavigation}
                                value={tabsState[shipment.shippingListId]}
                                onChange={(_, newValue) =>
                                    handleTabChangeForShipment(shipment.shippingListId, newValue)
                                }
                                showLabels
                                style={{
                                    gap: '5rem',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    marginLeft: '2rem',
                                }}
                            >
                                <BottomNavigationAction
                                    className={
                                        UOPD_DETAIL.bottomNavAction +
                                        ' ' +
                                        UOPD_DETAIL.bottomNavActionProductInfos
                                    }
                                    sx={tabsState[shipment.shippingListId] === 0 ? selectedTabStyles : undefined}
                                    value={0}
                                    style={{ fontWeight: 'bold', color: '#5b99f3' }}
                                    label={
                                        <div style={{ display: 'flex' }}>
                                            <ListIcon style={{ marginTop: '0.7rem' }} />
                                            <span
                                                className="heading-sm"
                                                style={{ marginLeft: '1rem', marginTop: '0.5rem' }}
                                            >
                                                {t('orderDetail.productInfos')}
                                            </span>
                                        </div>
                                    }
                                />
                                <BottomNavigationAction
                                    className={
                                        UOPD_DETAIL.bottomNavAction +
                                        ' ' +
                                        UOPD_DETAIL.bottomNavActionCargoInfos
                                    }
                                    sx={tabsState[shipment.shippingListId] === 1 ? selectedTabStyles : undefined}
                                    value={1}
                                    style={{ fontWeight: 'bold', color: '#eb8958' }}
                                    label={
                                        <div style={{ display: 'flex', width: '200px' }}>
                                            <img src={DeliveryCart} style={{ height: 'auto', width: '20px' }} alt="" />
                                            <span
                                                className="heading-sm"
                                                style={{ marginLeft: '1rem', marginTop: '0.5rem' }}
                                            >
                                                {t('orderDetail.cargoInfos')}
                                            </span>
                                        </div>
                                    }
                                />
                                <BottomNavigationAction
                                    className={
                                        UOPD_DETAIL.bottomNavAction +
                                        ' ' +
                                        UOPD_DETAIL.bottomNavActionShipmentStatusInfos
                                    }
                                    sx={tabsState[shipment.shippingListId] === 2 ? selectedTabStyles : undefined}
                                    value={2}
                                    style={{ fontWeight: 'bold', color: '#666463' }}
                                    label={
                                        <div style={{ display: 'flex', width: '200px' }}>
                                            <RestoreIcon style={{ marginTop: '0.2rem' }} />
                                            <span className="heading-sm" style={{ marginLeft: '1rem' }}>
                                                {t('orderDetail.shipmentStatuInfos')}
                                            </span>
                                        </div>
                                    }
                                />
                                <BottomNavigationAction
                                    className={
                                        UOPD_DETAIL.bottomNavAction +
                                        ' ' +
                                        UOPD_DETAIL.bottomNavActionCrossShipment
                                    }
                                    sx={tabsState[shipment.shippingListId] === 3 ? selectedTabStyles : undefined}
                                    value={3}
                                    style={{ fontWeight: 'bold', color: '#666463' }}
                                    label={
                                        <div style={{ display: 'flex', width: '200px' }}>
                                            <ShuffleIcon style={{ marginTop: '0.2rem' }} />
                                            <span className="heading-sm" style={{ marginLeft: '1rem' }}>
                                                {t('orderDetail.crossShipment')}
                                            </span>
                                        </div>
                                    }
                                />
                                {shipment.documentModel.documentVisible && (
                                    <BottomNavigationAction
                                        className={
                                            UOPD_DETAIL.bottomNavAction +
                                            ' ' +
                                            UOPD_DETAIL.bottomNavActionBillingInformation
                                        }
                                        sx={tabsState[shipment.shippingListId] === 4 ? selectedTabStyles : undefined}
                                        value={4}
                                        style={{ fontWeight: 'bold', color: '#666463' }}
                                        label={
                                            <div style={{ display: 'flex', width: '200px' }}>
                                                <ReceiptIcon style={{ marginTop: '0.2rem' }} />
                                                <span className="heading-sm" style={{ marginLeft: '1rem' }}>
                                                    {t('orderDetail.billingInformation')}
                                                </span>
                                            </div>
                                        }
                                    />
                                )}
                            </BottomNavigation>
                            <AccordionDetails>
                                {tabsState[shipment.shippingListId] === 0 && (
                                    <UserOrderProductTable
                                        shipment={shipment}
                                        saleCh={datas.saleOrderPlatform}
                                        isExpanded={expanded === 'panel' + index}
                                    />
                                )}
                                {tabsState[shipment.shippingListId] === 1 && (
                                    <UserCargoPackageDetails
                                        shipment={shipment}
                                        orderInformation={orderInformation}
                                    />
                                )}
                                {tabsState[shipment.shippingListId] === 2 && (
                                    <UserCargoStatusHistory shipment={shipment} />
                                )}
                                {tabsState[shipment.shippingListId] === 3 && (
                                    <UserCrossShipmentList shipment={shipment} />
                                )}
                                {tabsState[shipment.shippingListId] === 4 && shipment.documentModel.documentVisible && (
                                    <UserBillingInformation
                                        shipment={shipment}
                                        orderId={datas.orderId}
                                        customerId={datas.customerId}
                                    />
                                )}
                            </AccordionDetails>
                        </Accordion>
                    </>
                ))}
            </div>
            {/* Stokta Olmayan Ürünler */}
            {datas.hasOutOfStock && (
                <>
                    <h3>{t('orderDetail.outOfStockProducts')}</h3>
                    {datas.shippingListForBackofficeModels.map(
                        (outofstock: any, index: number) =>
                            outofstock.outofStockItems &&
                            outofstock.outofStockItems.length > 0 && (
                                <Accordion
                                    className={UOPD_DETAIL.outOfStockAccordion}
                                    expanded={expanded === 'panel2' + index}
                                    onChange={handleChange('panel2' + index)}
                                    key={index}
                                    style={{
                                        marginTop: '2rem',
                                        height: 'auto',
                                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                        marginBottom: '4rem',
                                        backgroundColor: '#FAE2DD',
                                    }}
                                >
                                    <AccordionSummary
                                        className={UOPD_DETAIL.outOfStockSummary}
                                        onClick={handleSummaryClick}
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={'panel2' + index + 'bh-content'}
                                        id={'panel2' + index + 'bh-header'}
                                    >
                                        <UserOrderAccordionHeader
                                            shipment={outofstock}
                                            orderId={datas.orderId}
                                            customerId={datas.customerId}
                                            isExpanded={expanded === 'panel2' + index}
                                            isOutofStockHeader={true}
                                            reshippingActionButtonAllowed={reshippingActionButtonAllowed}
                                        />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div style={{ textAlign: 'center' }}>
                                            <OutOfStock outofstock={outofstock} />
                                            <button
                                                className={UOPD_DETAIL.goToShipmentButton}
                                                style={{
                                                    borderRadius: '2rem',
                                                    width: '200px',
                                                    height: 'auto',
                                                    padding: '1rem',
                                                    cursor: 'pointer',
                                                    marginTop: '2rem',
                                                    backgroundColor: 'transparent',
                                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                                }}
                                                onClick={() => scrollToShipment(outofstock.shippingListId)}
                                            >
                                                <ArrowUpwardIcon
                                                    className={UOPD_DETAIL.goToShipmentIcon + ' bouncing-icon'}
                                                />
                                                {t('orderDetail.goToShipment')}
                                            </button>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            )
                    )}
                </>
            )}
            {datas && datas.shippingListForBackofficeModels.length == 0 && (
                <div className={UOPD_DETAIL.fraudControlWrapper}>
                    <UserShowProductOnFraudControl data={datas} />
                </div>
            )}

            {/* Ödeme Listesi */}
            <Accordion
                className={`paymentInfos ${UOPD_DETAIL.paymentAccordion}`}
                expanded={expanded === 'payment'}
                onChange={handleChange('payment')}
                style={{
                    height: 'auto',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                    marginBottom: '8rem',
                }}
            >
                <AccordionSummary
                    className={UOPD_DETAIL.paymentSummary}
                    onClick={handleSummaryClick}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={'payment'}
                    id={'payment'}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '1rem',
                        }}
                    >
                        <PaymentIcon style={{ marginTop: '0.3rem' }} />
                        <strong className="heading-md">{t('orderDetail.paymentList')}</strong>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <UserOrderPaymentInfos datas={datas} isExpanded={expanded === 'payment'} />
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default UserOrderProductDetail;
